import { useQuery } from "@tanstack/react-query";
import { getNotificationStats } from "src/utils";

export const NOTIFICATION_STATS_QUERY_KEY = ["notifications", "stats"];

export const useNotificationStatsQuery = () => {
  const token = sessionStorage.getItem("token");

  return useQuery({
    queryKey: NOTIFICATION_STATS_QUERY_KEY,
    queryFn: () => getNotificationStats(token),
    enabled: Boolean(token),
    staleTime: 30_000,
  });
};
